export const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  lightred: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  darkYellow: {
    primary: '#979c1e',
    secondary: '#a6a871'
  },
  orange: {
    primary: '#e38b08',
    secondary: '#fdddba',
  },
  purple: {
    primary: '#e005e8',
    secondary: '#f3b5f5',
  },
  green: {
    primary: '#12e61c',
    secondary: '#b5f5b8',
  },
  lightGreen: {
    primary: '#34ebc3',
    secondary: '#aaf0e1'
  },
  black: {
    primary: '#000000',
    secondary: '#000000',
  },
};
